import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

const WeChatIcon = (props: React.ComponentProps<typeof Svg>) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <Path
      fill="#07C160"
      d="M8.5 4C4.91 4 2 6.46 2 9.5c0 1.72.9 3.26 2.3 4.3L3.6 16l2.55-1.28c.72.2 1.48.31 2.27.31.17 0 .34-.01.5-.03C8.2 17.73 10.2 19 12.5 19c.3 0 .59-.03.87-.08-.28-.88-.44-1.82-.44-2.8 0-3.49 3.13-6.32 7-6.32.37 0 .73.03 1.08.08C19.6 6.7 16.4 4 12.5 4h-4Zm-2.2 3.1c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1Zm4.4 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1ZM12.5 10c-3.04 0-5.5 2.01-5.5 4.5 0 2.48 2.46 4.5 5.5 4.5.63 0 1.23-.09 1.8-.26l2.2 1.1-.6-1.9c1.1-.82 1.8-2 1.8-3.34 0-2.49-2.46-4.5-5.5-4.5Zm-2 2.6c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75Zm4 0c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75Z"
    />
  </Svg>
);

export default WeChatIcon;
